module.exports = __webpack_public_path__ + "icon-play.svg?a06fff2edc667651dbd662e65c59ae9e";